import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";

interface CreateCategoryDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  categoryName: string;
  onCategoryNameChange: (name: string) => void;
  onCreateCategory: () => void;
}

export const CreateCategoryDialog = ({
  isOpen,
  onOpenChange,
  categoryName,
  onCategoryNameChange,
  onCreateCategory,
}: CreateCategoryDialogProps) => {
  const { t } = useTranslation();
  
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('categories.createNewCategory')}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="categoryName">{t('categories.categoryName')}</Label>
            <Input
              id="categoryName"
              value={categoryName}
              onChange={(e) => onCategoryNameChange(e.target.value)}
              placeholder={t('categories.enterCategoryName')}
            />
          </div>
          <Button 
            onClick={onCreateCategory} 
            variant="gradient"
            className="w-full"
          >
            {t('categories.create')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
